import { CheckCircle2, CircleDot, Home, Package, PackageCheck, Truck } from "lucide-react";

// Etapas da entrega (mesma ordem do backend em shipments.py).
export const STEPS = [
  { id: "confirmado", label: "Pedido confirmado", icon: CheckCircle2 },
  { id: "preparando", label: "Preparando", icon: Package },
  { id: "enviado", label: "Postado / Enviado", icon: PackageCheck },
  { id: "transito", label: "Em trânsito", icon: Truck },
  { id: "saiu", label: "Saiu para entrega", icon: CircleDot },
  { id: "entregue", label: "Entregue", icon: Home },
];
export const stepLabel = (id) => STEPS.find((s) => s.id === id)?.label || "";
export const stepIndex = (id) => STEPS.findIndex((s) => s.id === id);

export const cleanCode = (raw = "") => raw.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
export const trackUrl = (code) => `${window.location.origin}/rastreio/${code}`;
export const correiosUrl = (code) => `https://rastreamento.correios.com.br/app/index.php?objetos=${encodeURIComponent(code)}`;

export const when = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "");
export const placeOf = (ev) => [ev?.city, ev?.place].filter(Boolean).join(" · ");

// Mensagem de WhatsApp do lojista para o cliente (link + etapa atual).
export const shipmentMessage = (s, ev) => {
  const name = (s.client_name || "").split(" ")[0];
  const lines = [`Olá${name ? `, ${name}` : ""}! Aqui é da *RC iPhones*.`];
  if (ev && ev.step !== "confirmado") {
    lines.push("", `Atualização do seu pedido (${s.item}):`, `*${stepLabel(ev.step)}*${placeOf(ev) ? ` — ${placeOf(ev)}` : ""}`);
    if (ev.note) lines.push(ev.note);
  } else {
    lines.push("", `Seu pedido (${s.item}) foi confirmado e você já pode acompanhar a entrega por aqui:`);
  }
  if (s.tracking_code) lines.push("", `Código de rastreio dos Correios: ${s.tracking_code}`);
  lines.push("", `Acompanhe: ${trackUrl(s.code)}`, `Seu código: *${s.code}*`, "", "Dica: abra o link e toque em *Ativar notificações* para ser avisado no celular a cada etapa.");
  return lines.join("\n");
};
